import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const Header = () => {
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
  const [isNavOpen, setIsNavOpen] = useState(false); // State to manage navbar visibility
  const location = useLocation(); // Get the current location (URL path)

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setHasScrolled(true);
    } else {
      setHasScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Toggle modal visibility
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Function to check if the current path matches the menu item's path
  const isActive = (path) => location.pathname === path;

  return (
    <header
      id="site-header"
      className={`fixed-top ${hasScrolled ? "scrolled" : ""}`} // Apply 'scrolled' class when scrolled
    >
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light stroke py-lg-0">
          <h1>
            <a className="navbar-brand logo-text" href="/Home">
              <span className="sub-color">
                SIDDHARTHA <span className="text-white"> HIGH SCHOOL</span>
              </span>
            </a>
          </h1>
          <button
            className="navbar-toggler collapsed"
            type="button"
            onClick={() => setIsNavOpen(!isNavOpen)}
            aria-expanded={isNavOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon fa icon-expand fa-bars"></span>
            <span className="navbar-toggler-icon fa icon-close fa-times"></span>
          </button>
          <div
            className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`}
            id="navbarScroll"
          >
            <ul className="navbar-nav mx-lg-auto my-2 my-lg-0 navbar-nav-scroll">
              <li className="nav-item">
                <a
                  className={`nav-link ${isActive("/Home") ? "active" : ""}`}
                  href="/Home"
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${isActive("/About") ? "active" : ""}`}
                  href="/About"
                >
                  About
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${
                    isActive("/Services") ? "active" : ""
                  }`}
                  href="/Services"
                >
                  Services
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${isActive("/Support") ? "active" : ""}`}
                  href="/Support"
                >
                  Contact
                </a>
              </li>
            </ul>
            {/* Search Icon */}
            <a
              id="call-link"
              href="tel:+917780663677 "
              style={{ display: "none" }}
            >
              Call
            </a>

            <button
              id="trigger-overlay"
              className="searchw3-icon me-xl-4 me-lg-3"
              type="button"
              onClick={() => document.getElementById("call-link").click()}
            >
              <i className="fas fa-phone-alt"></i>
            </button>
          </div>
        </nav>
      </div>

      {/* Search Modal */}
      {isModalOpen && (
        <div
          className="overlay overlay-slidedown"
          id="searchModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="searchModalLabel"
          aria-hidden={!isModalOpen}
        >
          <button
            type="button"
            className="overlay-close"
            onClick={toggleModal} // Close modal when clicked
          >
            <i className="fas fa-times"></i>
          </button>
          <nav className="w3l-formhny">
            <form action="#" method="GET" className="d-sm-flex search-header">
              <input
                className="form-control me-2"
                type="search"
                placeholder="Search here..."
                aria-label="Search"
                required
              />
              <button
                className="btn btn-style btn-secondary me-lg-3"
                type="submit"
              >
                Search
              </button>
            </form>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
